type ProspectNameLike = {
  firstName: string;
  lastName: string;
};

export const getNameForDisplay = (prospect?: ProspectNameLike): string => {
  if (!prospect) {
    return "";
  }

  return `${prospect.firstName} ${prospect.lastName}`;
};
